/** 待审批/申请中「申请时间 / 提交时间」：提审时刻（与 queueEnteredAt 同口径） */
export const getPendingApplyAt = (row) => {
	if (!row) return null;
	if (row.entryKind === 'customer') {
		return row.uiHints?.queueEnteredAt ?? row.createdAt ?? row.approval?.createdAt ?? null;
	}
	return row.uiHints?.queueEnteredAt ?? row.approval?.createdAt ?? row.createdAt ?? null;
};

export const buildPendingApplyAtColumn = (formatDateTime, header) => ({
	id: 'applyAt',
	accessorFn: (row) => {
		const at = getPendingApplyAt(row);
		if (!at) return 0;
		const time = new Date(at).getTime();
		return Number.isNaN(time) ? 0 : time;
	},
	header,
	meta: {
		headerProps: {
			className: 'text-end text-900',
		},
		cellProps: {
			className: 'text-end',
		},
	},
	cell: ({ row: { original } }) => {
		const applyAt = getPendingApplyAt(original);
		return <span className='fs-11'>{applyAt ? formatDateTime(applyAt) : '-'}</span>;
	},
});

export const PENDING_APPLY_AT_SORT = [{ id: 'applyAt', desc: true }];
